import css from './index.module.scss';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, TextWithImage, ImgCellsWithText } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getImageSpec } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import NextImage from '@/components/NextImage';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300'],
    cis: ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_256', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_delta_delta_3_s', 'product_ps_delta_delta_2_max', 'product_ps_delta_delta_pro'],
    ph: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
};

export default function SolarPanel() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('400wsolarpanel');
    const languageT = (value: string) => t(`solarpanels_400w.${value}`);
    const imgSpec = getImageSpec(locale, ['de', 'fr', 'es', 'it', 'za']);
    const webpUrl = '/media/solarpanel_400w/h5/';

    const imgCellData = {
        guide: languageT('ten_title'),
        title: languageT('ten_subtitle'),
        desc1: languageT('ten_des'),
        desc2: languageT('ten_des1'),
        items: [
            {
                url: ['1.webp', '1.jpg'],
                guide: languageT('ten_item_title'),
                titleLeft: languageT('ten_item_hours'),
                desc: languageT('ten_item_des'),
            },
            {
                url: ['2.webp', '2.jpg'],
                guide: languageT('ten_item1_title'),
                titleLeft: languageT('ten_item1_hours'),
                desc: languageT('ten_item1_des'),
            },
            {
                url: ['3.webp', '3.jpg'],
                guide: languageT('ten_item2_title'),
                titleLeft: languageT('ten_item2_hours'),
                desc: languageT('ten_item2_des'),
            },
            {
                url: [`4_${imgSpec}.webp`, `4_${imgSpec}.jpg`],
                guide: languageT('ten_item3_title'),
                titleLeft: languageT('ten_item3_hours'),
                desc: languageT('ten_item3_des'),
            },
        ],
    };
    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div className="page-solarpanel-banner">
                <BannerModule
                    data={[
                        {
                            bgImgs: ['banner.webp', 'banner.jpg'],
                            title: languageT('title'),
                            des: languageT('des'),
                        },
                    ]}
                    config={{ isShowLogo: false, webpUrl }}
                />
            </div>
            <div className="banner-content">
                <div className="section section1">
                    <h3 className="tit">{languageT('second_output')}</h3>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_400w/h5/bg-1.webp')}
                            src={require('@publicLocal/product/solarpanel_400w/h5/bg-1.jpg')}
                            className="fullImgs"
                            alt={languageT('second_output')}
                        />
                    </div>
                </div>
                <div className="section section2">
                    <div className="section sec2-top-l">
                        <h3
                            className="tit"
                            dangerouslySetInnerHTML={{
                                __html: t.raw('solarpanels_400w.second_adjustable_h5'),
                            }}
                        ></h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w/h5/bg-2.webp')}
                                src={require('@publicLocal/product/solarpanel_400w/h5/bg-2.jpg')}
                                className="fullImgs"
                                alt={languageT('second_kickstand_case_h5')}
                            />
                        </div>
                    </div>
                    <div className="section sec2-top-m">
                        <h3
                            className="tit"
                            dangerouslySetInnerHTML={{
                                __html: languageT('second_easy_to_plug_h5'),
                            }}
                        ></h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w/h5/bg-3.webp')}
                                src={require('@publicLocal/product/solarpanel_400w/h5/bg-3.jpg')}
                                className="fullImgs"
                                alt={languageT('second_easy_to_plug_h5')}
                            />
                        </div>
                    </div>
                    <div className="section sec2-top-r">
                        <h3 className="tit">
                            <span className="ip">{languageT('second_ip')}</span>
                            <span className="ipText">{languageT('second_waterproof')}</span>
                        </h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w/h5/bg-4.webp')}
                                src={require('@publicLocal/product/solarpanel_400w/h5/bg-4.jpg')}
                                className="fullImgs"
                                alt={languageT('second_waterproof')}
                            />
                        </div>
                    </div>
                </div>
                <div className="section section3">
                    <div className="section sec3-top-l">
                        <h3
                            className="tit tit1"
                            dangerouslySetInnerHTML={{
                                __html: languageT('second_hight_conversion_rate_h5'),
                            }}
                        ></h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w/h5/bg-5.webp')}
                                src={require('@publicLocal/product/solarpanel_400w/h5/bg-5.jpg')}
                                className="fullImgs"
                                alt={languageT('second_hight_conversion_rate_h5')}
                            />
                        </div>
                    </div>
                    <div className="section sec3-top-r">
                        <h3
                            className="tit"
                            dangerouslySetInnerHTML={{
                                __html: languageT('second_lightweight_h5'),
                            }}
                        ></h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_400w/h5/bg-6.webp')}
                                src={require('@publicLocal/product/solarpanel_400w/h5/bg-6.jpg')}
                                className="fullImgs"
                                alt={languageT('second_lightweight_h5')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT(locale === 'jp' ? 'third_title_h5' : 'third_title'),
                        desc: languageT('third_des'),
                        img_url: ['3_panels.webp', '3_panels.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg t4">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT('four_title_h5'),
                        desc: languageT('four_des'),
                        img_url: ['4.webp', '4.jpg'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        synopsisFontSize: locale === 'de' ? 0.22 : 0.24,
                        webpUrl,
                    }}
                    data={{
                        synopsis: languageT(locale === 'jp' ? 'five_title_h5' : 'five_title'),
                        title: languageT('five_tip'),
                        desc: languageT('five_des'),
                        img_url: ['5.webp', '5.jpg'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg t6">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT('six_title'),
                        title: languageT('six_tip'),
                        desc: languageT('six_des'),
                        img_url: ['6.webp', '6.jpg'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT('seven_title'),
                        title: languageT('seven_tip'),
                        desc: languageT('seven_des'),
                        img_url: ['7.webp', '7.jpg'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        tip_margintop: '0.15rem',
                        synopsisFontSize: locale === 'de' ? 0.22 : 0.24,
                        webpUrl,
                    }}
                    data={{
                        synopsis: languageT('eight_subtitle_h5'),
                        title: languageT('eight_title'),
                        desc: languageT('eight_des'),
                        tip: languageT('eight_tip'),
                        img_url: ['8.webp', '8.jpg'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg night_title">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        synopsisFontSize: locale === 'de' ? 0.21 : 0.24,
                        webpUrl,
                    }}
                    data={{
                        synopsis: languageT('night_subtitle_h5'),
                        title: languageT('night_title'),
                        desc: languageT('night_des'),
                        img_url: ['9.webp', '9.jpg'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="products">
                <ImgCellsWithText data={imgCellData} webpUrl={webpUrl} />
                {locale === 'cn' && <p className="memo">{languageT('memo')}</p>}
            </div>
            <LineSpace height={1.2} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
        </div>
    );
}
